import { Divider as AntDivider } from 'antd';
import styled from 'styled-components';

export const Divider = styled(AntDivider)`
    margin: 32px 0;
`;
